<script>
export default {
  props: {},

  data() {
    return {
      showChat: false,
      shop_id: this.$page.props.master_config.shop_id,
      unread: 0,
    };
  },

  computed: {},

  watch: {},

  mounted() {
    this.getUnread();
    this.pollInboundMessages();
  },

  methods: {
    openChat() {
      this.showChat = true;
      localStorage.chatstatus = 1;
    },

    getUnread() {
      axios.get(route('internalchat.unread', { shop_id: this.shop_id })).then((response) => {
        var vm = this;
        vm.unread = 0;
        const unread = response?.data?.data?.unread;
        $.each(unread, function (index, type) {
          $.each(type, function (id, count) {
            vm.unread = vm.unread + count;
          });
        });
      });
    },

    closeChat() {
      localStorage.chatstatus = 0;
      this.getUnread();
      this.showChat = false;
    },

    pollInboundMessages() {
      setInterval(() => {
        this.getUnread();
      }, 30000);
    },
  },
};
</script>

<template>
  <div
    v-if="!showChat"
    :class="unread ? 'chaticon chatbubble unreadmessage' : 'chaticon chatbubble'"
    @click="openChat"
  >
    <i class="fa fa-comment-dots" />
    <div v-if="unread > 0" id="unread" class="count">
      {{ unread }}
    </div>
  </div>

  <div v-if="showChat" id="chatframe">
    <div class="chat_tools">
      <i id="remove" class="fa fa-times-circle" @click="closeChat" />
    </div>
    <iframe
      :src="route('internalchat.index', { shop_id: shop_id })"
      width="100%"
      height="100%"
      frameBorder="0"
      seamless="seamless"
    />
  </div>
</template>

<style scoped>
.chaticon {
  position: fixed;
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
  right: 20px;
  bottom: 30px;
  width: 58px;
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 7px;
  border-radius: 100%;
  box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.25) !important;
  cursor: pointer;
  z-index: 10040;
  text-align: center;
}

.chaticon i {
  display: block;
  font-size: 30pt;
  line-height: 1;
  animation: pulsate 2s infinite;
}

#unread.count {
  color: #efefef;
  position: absolute;
  top: -5px;
  left: 30px;
  border-radius: 50px;
  background: red;
  padding: 0 8px;
  font-size: 12pt;
  font-weight: bold;
  box-shadow:
    0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12),
    0 3px 1px -2px rgba(0, 0, 0, 0.2) !important;
  font-family: monospace;
}

#chatframe {
  position: fixed;
  bottom: 12px;
  right: 20px;
  width: 320px;
  height: 496px;
  max-height: calc(100dvh - 24px);
  background: #fff;
  z-index: 10040;
  isolation: isolate;
  transition: height 1s ease-in-out;
  box-shadow:
    0 8px 17px 0 rgba(0, 0, 0, 0.2),
    0 6px 20px 0 rgba(0, 0, 0, 0.188235) !important;
  border-radius: 3px;
  transition: all 1s;
}

#chatframe iframe {
  position: relative;
  z-index: 1;
}

.chatbubble.unreadmessage {
  background: rgb(255 3 3);
  animation: pulsate 2s infinite;
}

.chat_tools {
  position: absolute;
  right: 8px;
  top: 8px;
  z-index: 2;
  border-radius: 50%;
  background: #bbb;
}

.chat_tools i {
  color: #fff;
  cursor: pointer;
  font-size: 18pt;
  font-weight: 500;
}

.chat_tools i:hover {
  color: #ddd;
}

@media (max-width: 767.98px), (orientation: landscape) and (max-height: 575.98px) {
  .chaticon {
    right: 12px;
    bottom: 12px;
  }

  #chatframe {
    right: 12px;
    bottom: 12px;
    width: min(320px, calc(100vw - 24px));
    height: min(496px, calc(100dvh - 24px));
    max-height: calc(100dvh - 24px);
  }

  .chat_tools {
    right: 6px;
    top: 6px;
  }
}
</style>
